module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/omelnickiy-a315780-bkg-3296a4ea747d68429bfa62cf73450a8e.jpg";